var swiperThumbs = new Swiper(".swiper.is-pdp-thumbs", {
  slidesPerView: 5,
  spaceBetween: 10,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
  speed: 500,
  slideToClickedSlide: true,
  watchSlidesProgress: true,
  on: {
    touchEnd: function(s,e) {
      let range = 5;
      let diff = s.touches.diff = s.isHorizontal() ? s.touches.currentX - s.touches.startX : s.touches.currentY 
                   - s.touches.startY
      if (diff < range || diff > -range) s.allowClick = true;
    }
  },
});

var swiperPDP = new Swiper(".swiper.is-pdp", {
  slidesPerView: 1,
  spaceBetween: 20,
  thumbs: {
    swiper: swiperThumbs
  },
  speed: 500,
});

var swiperHiw = new Swiper(".swiper.is-hiw", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  }, 
  breakpoints: {
    479: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    }
  },
  speed: 500,
});

var swiperTestimonials = new Swiper(".swiper.is-testimonials", {
  slidesPerView: 'auto',
  centeredSlides: true,
  spaceBetween: 20,
  loop: true,
  autoplay: true,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
  speed: 500,
});

var swiperTestimonials = new Swiper(".swiper.is-product-images", {
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  },
  breakpoints: {
    479: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    }
  },
  speed: 500,
});

var swiperProcess = new Swiper(".swiper.is-process", {
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true'
  }, 
  breakpoints: {
   768: {
      slidesPerView: 2,
    },
    991: {
      slidesPerView: 3,
    }
  },
  speed: 500,
});


var acc = document.getElementsByClassName("faqs-item");
var i;
for (i = 0; i < acc.length; i++) {
acc[i].addEventListener("click", function() {
    if (this.classList.contains('open')) {
    this.classList.toggle('open');
    } else {
    $('.faqs-item').removeClass('open');
    this.classList.toggle('open');
    }
});
}

ScrollTrigger.create({
    trigger: ".footer-logo",
    start: "top 80%",
    end: "bottom top",
    toggleClass: {targets: ".footer-logo", className: "is-visible"}
});